import {BottomSheet} from 'react-spring-bottom-sheet';

import 'react-spring-bottom-sheet/dist/style.css';
import 'assets/css/wheelpicker.css';
import BirthDate from './Birthdate';
import DiabetYear from './DiabetYear';

export default function WheelWrapper(props) {
  const {showToast, label, name, changeHandler, closeToastHandler, value} =
    props;

  const wheelchangeHandler = (value) => changeHandler(value);

  return (
    <BottomSheet
      open={showToast}
      onDismiss={closeToastHandler}
      snapPoints={({minHeight}) => minHeight}>
      <p className='headerPTag'>
        <span>{label}</span> بیمار را انتخاب کنید
      </p>
      {name === 'birthDate' && (
        <BirthDate
          value={value}
          changeHandler={wheelchangeHandler}
          closeToastHandler={closeToastHandler}
        />
      )}
      {name === 'yearsWithDiabet' && (
        <DiabetYear
          value={value}
          changeHandler={wheelchangeHandler}
          closeToastHandler={closeToastHandler}
        />
      )}
    </BottomSheet>
  );
}
